import React from "react";
import { BaseFilterProps } from "../../lib";
import { ClientMultiselect } from "../ClientMultiselect/ClientMultiselect";

/**
 * Multi-select filter for the Organization > Work page — filters by the
 * close's Client (workspace), matched against `close.workspaceId`. Mirrors
 * ScheduleClientFilter (Schedules page), which uses the same "client =
 * workspace" concept but is keyed under a distinct filter (`scheduleClientIds`).
 */
export const WorkClientFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <ClientMultiselect
        name="workClient"
        clientIds={filters.workClientIds}
        onClientIdsChange={(workClientIds) => onChange({ workClientIds })}
    />
);
